import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import ngCookies from 'angular-cookies';
import routing from './demand_report_show.routes';

import SaConfigService from '../../../components/api/sa_config/sa_config.service';
import MonthlyMaxDemandPowerService from '../../../components/api/monthly_max_demand_power/monthly_max_demand_power.service';
import WeatherService from '../../../components/api/weather/weather.service';

export class DemandReportShowController {
  /*@ngInject*/
  constructor($state, $stateParams, $cookies, SaConfigService, MonthlyMaxDemandPowerService) {
    this.id = $stateParams.id;
    this.cookies = $cookies;
    this.state = $state;
    this.SaConfigService = SaConfigService;
    this.MonthlyMaxDemandPowerService = MonthlyMaxDemandPowerService;
    this.type = $stateParams.type || this.cookies.get('report_type') || 'demand';
    this.term = $stateParams.term || this.cookies.get('report_term') || 'daily';
    this.showSaInfo = false;
    this.sa = null;
  }

  $onInit() {
    this.saConfigPromise = this.SaConfigService.api.show({id: this.id}).$promise;
    this.saConfigPromise.then(response => {
      this.location = response.location;
      this.memo = response.memo;
      this.targetPower = response.target_power;
      this.limitPower = response.limit_power;
      this.contractPower = response.contract_power;
      this.billingDate = response.billing_date;
      this.pms_service_code = response.pms_service_code;
      this.distribution_id = response.distribution_id;
      this.sa = response;
    });

    this.saConfigPromise.catch(err => {
      if (err.status === 404 || err.status === 403) {
        this.state.go('main.home');
      }
    });

    this.MonthlyMaxDemandPowerService.show(
      {id: this.id},
      response => {
        this.monthlyMaxPower = response;
      },
      error_response => {
        this.monthlyMaxPower = null;
      }
    );

    this.MonthlyMaxDemandPowerPromise = this.MonthlyMaxDemandPowerService.showYearly({id: this.id}).$promise;
    this.MonthlyMaxDemandPowerPromise.then(response => {
      if (response.powers.length === 0) {
        this.yearlyMaxPower = null;
        return;
      }

      let yearlyMaxPower = response.powers[0];
      for (let power of response.powers) {
        if (power.value > yearlyMaxPower.value) {
          yearlyMaxPower = power;
        }
      }

      this.yearlyMaxPower = yearlyMaxPower;
    });
  }

  changeType(type) {
    this.cookies.put('report_type', type);
    this.type = type;

    if (type === 'price' && (this.term === 'weekly' || this.term === 'yearly')) {
      this.changeTerm('daily');
    }
  }

  changeTerm(term) {
    this.cookies.put('report_term', term);
    this.term = term;
  }

  toggleSaInfo() {
    this.showSaInfo = !this.showSaInfo;
  }
}

export default angular.module('leptonApp.demandReportShow', [uiRouter, ngCookies, SaConfigService, MonthlyMaxDemandPowerService])
  .config(routing)
  .component('demandReportShow', {
    template: require('./demand_report_show.html'),
    controller: DemandReportShowController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/demand_report/show/demand_report_show.component.js